import React from 'react';

import { Box, Stack } from '@mui/material';

import PaginationButtons from './PaginationButtons';
import PaginationCount from './PaginationCount';

type Props = {
  setPage: (v: number) => void;
  currentPage?: number;
  limit?: number;
  count?: number;
};

export default function Pagination({ setPage, currentPage, limit, count }: Props) {
  return (
    <Stack direction="row" alignItems="center" flexShrink={0}>
      <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
        <PaginationCount currentPage={currentPage} limit={limit} count={count} />{' '}
      </Box>
      <PaginationButtons setPage={setPage} currentPage={currentPage} limit={limit} count={count} />
    </Stack>
  );
}
